import { gql } from '@apollo/client'

// mutation name changed
export default gql(`
    mutation deleteVirtualAssetImages($deletedId: [ID]! $assetId: ID! $project: String $module: String!) {
        deleteVirtualAssetImages(
            input:  $deletedId,
            assetId: $assetId,
            project: $project,
            module: $module,
        )
    }`
)
